<template>
  <div class="full-page-loader">
    <img
      src="@/assets/temp/logo.svg"
      alt="ProTipster"
      class="full-page-loader__logo"
    />
  </div>
</template>

<script setup>
</script>

<style scoped>
.full-page-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: #fff;
}

.full-page-loader__logo {
  width: 80px;
  height: auto;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.92);
  }
}
</style>
